import { render, staticRenderFns } from "./ShapeOutline.vue?vue&type=template&id=3f5754ea"
import script from "./ShapeOutline.vue?vue&type=script&lang=js"
export * from "./ShapeOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports